import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { InputGroup, InputRightElement, Flex } from '@chakra-ui/react';
import Text from './../Text';
import theme from './../theme/theme';
import {
  Input,
  Wrapper,
  Label,
  IconWrapper,
} from './TextField.styles'; /** * Represents an input in forms. */

function TextField(
  {
    label,
    footnote,
    customFootnote = null,
    id,
    type = 'text',
    errorIcon = null,
    errorMessage = '',
    handleChange,
    handleBlur,
    value,
    width,
    minHeight,
    maxWidth,
    fontSize,
    fontWeight,
    disableFields,
    marginTop,
    marginRight,
    marginLeft,
    marginBottom,
    textAlign,
    icon,
    iconWidth,
    iconClick = () => {},
    hideFootnoteOnError = false,
    ...rest
  },
  ref
) {
  return (
    <Wrapper
      width={width}
      maxWidth={maxWidth}
      minHeight={minHeight}
      marginRight={marginRight}
      marginLeft={marginLeft}
      marginTop={marginTop}
      marginBottom={marginBottom}
    >
      {' '}
      {label && (
        <Label htmlFor={id} color={errorMessage}>
          {' '}
          {label}{' '}
        </Label>
      )}{' '}
      <InputGroup>
        {' '}
        <Input
          id={id}
          ref={ref}
          name={id}
          type={type}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          disabled={disableFields}
          borderColor={errorMessage}
          textAlign={textAlign}
          fontSize={fontSize}
          fontWeight={fontWeight}
          {...rest}
        />{' '}
        {icon && (
          <IconWrapper>
            {' '}
            <InputRightElement
              top="unset"
              width={iconWidth || '4.5rem'}
              height="3.25rem"
              onClick={(e) => {
                iconClick(e);
              }}
            >
              {' '}
              {icon}{' '}
            </InputRightElement>{' '}
          </IconWrapper>
        )}{' '}
      </InputGroup>
      {!customFootnote &&
        footnote &&
        !(hideFootnoteOnError && errorMessage) && (
          <Text size="small" color={theme.colors.gray['600']} pl="16px">
            {' '}
            {footnote}{' '}
          </Text>
        )}{' '}
      {!footnote && !(hideFootnoteOnError && errorMessage) && customFootnote}{' '}
      <Flex
        alignItems="center"
        color="semantics.error"
        pl={errorIcon ? '0px' : '16px'}
      >
        {' '}
        {errorMessage && errorIcon} <Text size="small">{errorMessage}</Text>{' '}
      </Flex>{' '}
    </Wrapper>
  );
}
TextField.propTypes = {
  label: PropTypes.string,
  footnote: PropTypes.string,
  customFootnote: PropTypes.node,
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  errorIcon: PropTypes.node,
  errorMessage: PropTypes.string,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  minHeight: PropTypes.string,
  marginRight: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  disableFields: PropTypes.bool,
  marginTop: PropTypes.string,
  marginLeft: PropTypes.string,
  marginBottom: PropTypes.string,
  textAlign: PropTypes.string,
  icon: PropTypes.node,
  iconWidth: PropTypes.string,
  iconClick: PropTypes.func,
  hideFootnoteOnError: PropTypes.bool,
};
export default forwardRef(TextField);
